import MenuButton from "./Menu";

export default {
    button: MenuButton,
    name: "menu",
};
